import { combineLatest } from "rxjs";
import { filter, ignoreElements, take, tap } from "rxjs/operators";
import { TypeActionBuildings } from "../../player-base/buildings/actionBuildings";
export var epicViewportResumeZoom = function (action$, state$, deps) {
    var deselect$ = action$.pipe(filter(function (action) {
        return action.type === TypeActionBuildings.Deselect ||
            action.type === TypeActionBuildings.StartMove;
    }));
    var viewport$ = deps.inStoreDependencies.viewportChanged$.pipe(filter(function (viewport) { return !!viewport; }), take(1));
    return combineLatest(deselect$, viewport$).pipe(tap(function (_a) {
        var action = _a[0], viewport = _a[1];
        viewport.resumePlugin("wheel");
        viewport.resumePlugin("pinch");
    }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/viewport/epics/epicViewportResumeZoom.ts
// module id = 2501
// module chunks = 3